import { render, staticRenderFns } from "./update-device.vue?vue&type=template&id=2d4f56d3"
import script from "./update-device.vue?vue&type=script&lang=js"
export * from "./update-device.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports